import { methods, request } from "./base";

const Wallet = {
  createWalletId: async (payload?: object) => {
    const route = "/wallet/create-user";
    return await request({
      route,
      method: methods.POST,
      priv: true,
      payload,
    });
  },
  fetchWalletAmount: async (payload?: object) => {
    const route = "/wallet/fetch-money";
    return await request({
      method: methods.GET,
      route,
      priv: true,
      payload,
    });
  },
  fetchWalletStatement: async (payload?: object) => {
    const route = "/wallet/fetch-statement";
    return await request({
      method: methods.POST,
      route,
      priv: true,
      payload,
    });
  },
  loadMoneny: async (payload?: object) => {
    const route = "/wallet/load-money";
    return await request({
      method: methods.POST,
      route,
      priv: true,
      payload,
    });
  },
  fetchWalletOptionPlans: async (payload?: object) => {
    const route = "/patient_plans/home_page_plans";
    return await request({
      method: methods.POST,
      route,
      priv: true,
      payload,
    });
  },
};

export default Wallet;
